import { INutritionAppQty, INutritionPlanCroppingApp, ProductAppInput } from "../../../types";
import { ProductApplicationVm } from "./productApplicationVm";

export class CroppingOverride implements INutritionAppQty {

    _nutrientPct: number;
    _nutrientRate: number;
    _productRate: number;

    _lastInputUsed: ProductAppInput;

    constructor(private _app: ProductApplicationVm, private _croppingId: number, public model?: INutritionPlanCroppingApp) {

        this.LastInputUsed = (model ? model.LastInputUsed : _app.lastInputUsed);

        this._nutrientPct = (model ? model.NutrientPct : _app.nutrientPct);
        this._nutrientRate = (model ? model.NutrientRate : _app.nutrientRate);
        this._productRate = (model ? model.ProductRate : _app.productRate);

    }

    set NutrientPct(value: number) {
        this._nutrientPct = value;
        this.refreshModel();
    }

    get NutrientPct(): number {
        return this._nutrientPct;
    }

    set NutrientRate(value: number) {
        this._nutrientRate = value;
        this.refreshModel();
    }

    get NutrientRate(): number {
        return this._nutrientRate;
    }

    set ProductRate(value: number) {
        this._productRate = value;
        this.refreshModel();
    }

    get ProductRate(): number {
        return this._productRate;
    }

    set LastInputUsed(value: ProductAppInput) {
        this._lastInputUsed = value;
    }

    get LastInputUsed(): ProductAppInput {
        return this._lastInputUsed;
    }

    get CutOffProductRate(): number {
        return this._app.productApp.CutOffProductRate
    }

    get MinProductRate(): number {
        return this._app.productApp.MinProductRate
    }

    get MaxProductRate(): number {
        return this._app.productApp.MaxProductRate
    }

    get croppingId(): number {
        return this._croppingId;
    }

    private refreshModel() {
        if (this.model) {
            this.model.NutrientRate = this.NutrientRate;
            this.model.NutrientPct = this.NutrientPct;
            this.model.ProductRate = this.ProductRate;
            this.model.LastInputUsed = this.LastInputUsed;
        }
    }

    public clone(app: ProductApplicationVm): CroppingOverride {

        var c = new CroppingOverride(app, this._croppingId);

        c.NutrientPct = this.NutrientPct;
        c.NutrientRate = this.NutrientRate;
        c.ProductRate = this.ProductRate;
        c.LastInputUsed = this.LastInputUsed;

        return c;

    }


    compareTo(other: INutritionAppQty): boolean {

        if (other) {

            return (other.NutrientPct == this.NutrientPct)
                && (other.NutrientRate == this.NutrientRate)
                && (other.ProductRate == this.ProductRate);

        }
    }

}
